import usePeriodLevels from "backend/hooks/model/usePeriodLevels";
import React from "react";
import { IPeriod, IPeriodLevel } from "backend/model/model";
import PeriodSelectorDesign from "design/components/toolbar/PeriodSelectorDesign";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";

const PeriodSelector = (props: { level?: string }) => {
  const { data: periodlevels } = usePeriodLevels();
  const link = useLink();
  const ctx = useAppContext();
  const [activePeriod, setActivePeriod] = React.useState<IPeriod | undefined>();
  const [activePeriodLevel, setActivePeriodLevel] = React.useState<
    IPeriodLevel | undefined
  >();

  React.useEffect(() => {
    // if first time this is used
    if (periodlevels && !activePeriodLevel && ctx.period) {
      periodlevels.forEach((level) => {
        level.periods.forEach((period) => {
          if (period.name === ctx.period) {
            setActivePeriod(period);
            setActivePeriodLevel(level);
          }
        });
      });
    }
  }, [periodlevels, activePeriod?.name, ctx.period]);

  const usedPeriodLevels = React.useMemo(() => {
    if (props.level) {
      return periodlevels?.filter((l) => l.name === props.level);
    }
    if (periodlevels) return periodlevels;
    return [];
  }, [props.level, periodlevels]);

  if (!periodlevels || !usedPeriodLevels) return null;

  return (
    <div>
      <PeriodSelectorDesign
        periodlevels={usedPeriodLevels}
        selectedLevel={activePeriodLevel}
        selectedPeriod={activePeriod}
        onSelectPeriod={(value) => {
          periodlevels.forEach((l) => {
            l.periods.forEach((period) => {
              if (period.id === value) {
                setActivePeriod(period);
                link({ period: period.name });
              }
            });
          });
        }}
        onSelectLevel={(value) => {
          setActivePeriodLevel(
            periodlevels.filter((pl) => pl.id === value).pop()
          );
          setActivePeriod(undefined);
        }}
      />
    </div>
  );
};

export default PeriodSelector;
